export default __webpack_public_path__ + "static/media/logo.bd5f8cf8.png";